import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { CatalogBasic } from 'src/app/models/catalogs-model/catalog.model';
import { CatalogsService } from 'src/app/services/catalogs-services/catalogs-services/catalogs.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { empty } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';

@Component({
  selector: 'app-catalogs-catalog-desks-card',
  templateUrl: './catalogs-catalog-desks-card.component.html',
  styleUrls: ['./catalogs-catalog-desks-card.component.scss']
})
export class CatalogsCatalogDesksCardComponent implements OnInit, OnDestroy {

  @Input() catalog: CatalogBasic;
  @Input() desks;
  selectedDesks;
  updateCatalogDesksSubscription: Subscription;
  getCatalogDesksSubscription: Subscription;
  listenCatalogDesksRefreshSubscription: Subscription;

  constructor(private catalogsService: CatalogsService,
              private snackbarService: SnackBarService) { }

  ngOnInit() {
  }

  public duallistboxOutputEventReceiver(selectedDesks) {
    const aux = new Array();
    for (const d of selectedDesks) {
      aux.push(d[1]._data);
    }
    if (aux) {
      this.selectedDesks = aux;
      this.updateCatalogDesks(this.getDesksInternalIds(this.selectedDesks));
    }
  }

  public updateCatalogDesks(desksInternalIds) {
    this.updateCatalogDesksSubscription = this.catalogsService.updateCatalogDesks(this.catalog.InternalId, desksInternalIds).pipe(
      tap(o => this.catalogsService.refreshCatalog()),
      tap(o => this.snackbarService.open('catalogs-page.snackbar messages.update catalog success', 'success')),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return empty(); })
    ).subscribe();
  }

  private getDesksInternalIds(desks) {
    if (desks) {
      return desks.map(d => d.TurnDeskInternalId);
    }
    return [];
  }

  ngOnDestroy() {
    if (this.updateCatalogDesksSubscription) { this.updateCatalogDesksSubscription.unsubscribe(); }
    if (this.getCatalogDesksSubscription) { this.getCatalogDesksSubscription.unsubscribe(); }
    if (this.listenCatalogDesksRefreshSubscription) { this.listenCatalogDesksRefreshSubscription.unsubscribe(); }
  }

}
